import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useTranslation } from 'react-i18next';

// Flag URLs or local imports
import arFlag from '../../assets/icons/languageIconsSvg/Lng-Ar.svg'; // 🇦 Arabic flag
import enFlag from '../../assets/icons/languageIconsSvg/Lng-En.svg'; // 🇺🇸 English flag

const LanguageSwitcher = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  const languages = [
    { code: 'en', label: 'English', flag: enFlag },
    { code: 'ar', label: 'العربية', flag: arFlag }
  ];

  const handleChange = (event) => {
    const newLang = event.target.value;
    i18n.changeLanguage(newLang);
    document.documentElement.setAttribute('dir', newLang === 'ar' ? 'rtl' : 'ltr');
    document.documentElement.lang = newLang;
    localStorage.setItem("selectedLanguage", newLang); 
  };

  return (
    <div className='flex justify-center bg-white sm:p-2 p-1 rounded-[10px]'>
    <FormControl sx={{width: '60px'}} variant="outlined" size="small" >
      <InputLabel id="language-select-label">{t('AIGen.Language')}</InputLabel>
      <Select
        labelId="language-select-label"
        value={currentLang}
        label={t('AIGen.Language')}
          onChange={handleChange}
          sx={{
            // width: '70%',
            // padding:"4px",
            '& .MuiSelect-select': {
              textAlign: i18n.language === 'ar' ? 'right' : 'left',
              direction: i18n.language === 'ar' ? 'rtl' : 'ltr',
            },
            '& .MuiSelect-icon': {
              right: i18n.language === 'ar' ? 'unset' : '0px',
              left: i18n.language === 'ar' ? '0px' : 'unset',
            },
          }}
        renderValue={(value) => {
          const selected = languages.find((lang) => lang.code === value);
          return (
            <div className={`flex  ${currentLang==='ar'?'-ms-7':'-me-5 -ms-2'}`}>
              <img
                src={selected.flag}
                alt={selected.label}
                width={35}
                // style={{ marginInlineEnd: 4, marginInlineStart: -4 }}
              />
              {/* <span>{selected.label}</span> */}
            </div>
          );
        }}
      >
        {languages.map((lang) => (
          <MenuItem key={lang.code} value={lang.code}>
            {/* <Box display="flex" alignItems="center"> */}
              <img
                src={lang.flag}
                alt={lang.label}
                width={35}
                // style={{ marginInlineEnd: 4, marginInlineStart: -4 }}
              />
              {/* <span className='mx-5'>{lang.label}</span> */}
            {/* </Box> */}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
    </div>
  );
};

export default LanguageSwitcher;
